/* eslint-disable no-unused-vars */
import React, {Suspense, useEffect, useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './tooltip.css'; 

import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/index';
import { Toaster } from 'react-hot-toast';
//https://react-hot-toast.com/  
//https://react-hot-toast.com/docs/toaster

// Fonts: add to your index.html<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600&family=DM+Sans:wght@400;500&display=swap" rel="stylesheet" />

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store} >
  <Suspense>
  <App /> 
  <Toaster
    gutter={4}
    toastOptions={{
      duration: 3500,
      removeDelay: 1000,
      position : 'top-right',
      success : {
        style : {
          border : '3px solid green',
          borderRadius : '10px',
          background : '#d0f7d1',
          fontWeight : 'semiBold',
          color : 'green',
          margin: '2px'
        }
      },
      error : {
        style : {
          border : '3px solid red',
          borderRadius : '10px',
          background : '#f7d0e0',
          fontWeight : 'semiBold',
          color : 'red',
          margin: '2px'
        }
      }
    }} 
  />
  </Suspense>
  </Provider>
);

// create toastOptions styles for success and error for 'react-hot-toast


// toastOptions={{
//       duration: 3500,
//       removeDelay: 1000,
//       position : 'top-right',
//       style : {
//         border : '8px solid green',
//         background : '#283046',
//         color : 'white',
//         margin: '6px'
//       }
//     }} 


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
